import React from "react";

export default function Digit({props}){
    return (
        <div className="digit">
            {props.val}
        </div>
    )
}